import { withProps } from 'recompose';
import { Checkbox } from '@material-ui/core';
import CheckContainer from './check_container';

export default withProps(() => ({ component: Checkbox }))(CheckContainer);
